module.exports = require("angular-moment");